
import React from "react";
import StatusTags from "../../../Tags/StatusTags";
import Button from "../../../Buttons/Button";
import SmartTooltip from "../../../Info/SmartTooltip";

const ApInvoicesHeader = ({
  data,
  onBack,
  buttonType = "default",
  handleSave,
}) => {
  const {
    logo,
    title,
    invoiceNumber,
    invoiceStatus,
    showButtons = false,
    syncStatus = 1, // Not-Synced, Synced, Partially Synced
  } = data;

  const renderButtons = () => {
    if (!showButtons) return null;

    switch (buttonType) {
      case "approve_reject":
        return (
          <div className="flex gap-3" data-print="false">
            <Button
              size="sm"
              title={"Back"}
              icon={"arrow_left_alt"}
              onClick={onBack}
            />
            <Button
              size="sm"
              title={"Approve"}
              onClick={() => handleSave(3)}
              color={"success"}
            />
            <Button
              size="sm"
              title={"Reject"}
              onClick={() => handleSave(4)}
              color={"danger"}
            />
          </div>
        );

      case "sync":
        return (
          <div className="flex gap-3">
            <Button
              size="sm"
              title={"Back"}
              icon={"arrow_left_alt"}
              onClick={onBack}
            />
            <Button
              size="sm"
              title={"Sync to QB"}
              icon={"arrow_left_alt"}
              color={"success"}
              onClick={() => {}}
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div
      className={`flex justify-between mt-3 mb-6 items-center ${
        showButtons ? "flex-row-reverse" : ""
      }`}
    >
      <div>{renderButtons()}</div>
      <div className="flex justify-center">
        {logo && <img src={logo} alt="logo" />}
      </div>
      <div className="flex flex-col justify-center gap-1">
        <div className="body-two text-black">
          <SmartTooltip
            description={"Needs QuickBooks Sync!"}
            color="warning"
            variant="outlined"
            size="xs"
            noTooltip={syncStatus !== 3}
          >
            <span className="text-neutral-500">AP Invoice No</span>: #
            {invoiceNumber}
          </SmartTooltip>
        </div>
        <div className="flex">
          {/* <Tag
            title={title}
            variant="outlined"
            color="black"
            className=" !text-neutrals !py-1"
          /> */}
          <StatusTags tag={invoiceStatus} icon />
        </div>
      </div>
    </div>
  );
};

export default ApInvoicesHeader;
